module.exports = __webpack_public_path__ + "img/24616.54cd685d.svg";